
import React, { useEffect, useState } from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import Loading from "../../../components/common/Loading";
import { Oval } from "react-loader-spinner";

const policySections = {
  effectiveDate: "[Insert Effective Date]",
  title: "Privacy Policy",
  introduction:
    "This Privacy Policy describes how <strong> MCITI Services Private Limited </strong> collects, uses, discloses, and protects the personal information of users of the Training Management CRM ('Platform'), which is provided on a license basis to candidates associated with IHFC (I-Hub Foundation for Cobotics, IIT Delhi). By accessing or using the Platform, you acknowledge that you have read, understood, and agree to the terms of this Privacy Policy.",
  shortIntro: "By accessing or using the Platform, you acknowledge that you have read, understood, and agree to the terms of this Privacy Policy.",
  sections: [
    {
      id: 1,
      title: "Scope and Applicability",
      content:
        "This Privacy Policy applies to all personal information collected through the use of the Training Management CRM by authorized users, including candidates, trainers, administrators, and other users licensed under IHFC programs. This policy does not apply to third-party websites or services linked from our platform.",
    },
    {
      id: 2,
      title: "Information We Collect",
      subsections: [
        {
          subtitle: "a. Information You Provide Directly",
          points: [
            "Full name, email address, phone number, and address",
            "Date of birth, gender, and identity documents (if required for verification)",
            "Academic and professional background",
            "User account credentials (username, password)",
            "Application forms and supporting documents",
            "Feedback, support requests, and communications",
          ],
        },
        {
          subtitle: "b. Information We Collect Automatically",
          points: [
            "Device type, operating system, and browser type",
            "IP address and geolocation (city/region-level)",
            "Login timestamps and session duration",
            "Usage data (pages accessed, features used, errors encountered)",
          ],
        },
      ],
    },
    {
      id: 3,
      title: "How We Use Your Information",
      content: "We use the collected information for the following purposes:",
      points: [
        "To create, manage, and maintain user accounts",
        "To provide access to CRM features and services",
        "To facilitate training program management, tracking, and reporting",
        "To communicate with users regarding program updates, support, or policy changes",
        "To ensure the security and integrity of the platform",
        "To analyze usage data to improve platform performance and user experience",
        "To comply with applicable laws and legal obligations",
      ],
    },
    {
      id: 4,
      title: "Legal Basis for Processing",
      content: "We process your personal information based on one or more of the following legal bases:",
      points: [
        "Performance of a contract: To provide services under our license agreement with IHFC",
        "Legal obligations: To comply with regulatory or statutory requirements",
        "Legitimate interests: To ensure platform security, monitor performance, and improve services",
        "Consent: Where applicable, such as for marketing communications (if any)",
      ],
    },
    {
      id: 5,
      title: "Disclosure of Information",
      content: "We do not sell or rent your personal information. However, we may share information with:",
      points: [
        "IHFC: As the licensing entity, for training administration and program oversight",
        "Service Providers: Third-party vendors involved in hosting, analytics, or support (bound by confidentiality obligations)",
        "Law Enforcement or Government Authorities: When required by law, legal process, or to protect rights or safety",
        "Successors: In the event of a merger, acquisition, or business transfer, your data may be transferred accordingly",
      ],
    },
    {
      id: 6,
      title: "Data Retention",
      content:
        "We retain your personal information for as long as necessary to fulfill the purposes outlined in this Policy, including compliance with legal, accounting, or reporting requirements. Upon termination of your account or end of licensing term, data may be archived or anonymized unless otherwise required by law or IHFC’s policies.",
    },
    {
      id: 7,
      title: "Data Security",
      content:
        "We implement appropriate technical and organizational security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. These include data encryption, secure login protocols, and access control measures.",
      introduction: "However, no method of transmission or storage is 100% secure. While we strive to protect your information, we cannot guarantee absolute security."
    },
    {
      id: 8,
      title: "Changes to This Privacy Policy",
      content:
        "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated 'Effective Date'. Your continued use of the Platform after such changes constitutes acceptance of the revised Policy.",
    },
    // {
    //   id: 9,
    //   title: "Contact Us",
    //   content: "If you have any questions, concerns, or requests regarding this Privacy Policy or your personal information, please contact:",
    //   contactDetails: {
    //     company: "MCITI Services Private Limited",
    //     address: `105, Aggarwal Plaza Complex,  Mukherjee Nagar Delhi, Delhi 110009, IN`,
    //     email: "[Insert Contact Email]",
    //     phone: "[Insert Contact Number]",
    //   },
    // },
  ],
};

const PrivacyPolicy = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  }, []);

  return (
    <div className="content-inner">
      {loading
        ? <div
          className="d-flex justify-content-center "
          style={{ height: "85vh", paddingTop: "15vh" }}
        >
          <Oval
            height="50"
            width="50"
            color="#4fa94d"
            secondaryColor="#4fa94d"
          />
        </div>
        : (<Container>
          <Row>
            <Col lg="12" className="mb-4">
              <div className="bg-primary text-white text-center py-4 rounded shadow">
                <h2 className="mb-0 text-white">Privacy Policy</h2>
                <p className="mb-0 px-2 mt-2" style={{ lineHeight: "1.4" }}>
                  Your privacy is important to us — learn how we protect your
                  data.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="12" className="mt-3">
              <Card key={'policy-first-block'} className="p-3 p-md0">
                <Card.Header className="d-flex justify-content-between pb-0">
                  <div className="header-title">
                    <h4 className="card-title">{policySections?.title}</h4>
                  </div>
                </Card.Header>
                <Card.Body className="py-2 ">
                  {/* <p>{policySections?.introduction}</p> */}
                  <p dangerouslySetInnerHTML={{ __html: policySections.introduction }} />
                  <p>{policySections?.shortIntro}</p>
                </Card.Body>
              </Card>


              {policySections?.sections?.map((section, index) => (
                <Card key={index} className="p-3 p-md0">
                  <Card.Header className="d-flex justify-content-between pb-0">
                    <div className="header-title">
                      <h4 className="card-title ">{section?.title}</h4>
                    </div>
                  </Card.Header>
                  <Card.Body className="py-2 ">
                    {section?.content && <p>{section.content}</p>}
                    {section?.introduction && <p>{section.introduction}</p>}
                    {/* {section?.lists && (
                      <ul className="pt-0 px-">
                        {section?.lists?.map((item) => <li>{item}</li>)}
                      </ul>
                    )} */}
                    {section?.points && (
                      <ul>
                        {section?.points?.map((point, i) => <li key={i} className="pb-1">{point}.</li>)}
                      </ul>
                    )}
                    {section.subsections && section.subsections.map((sub, j) => (
                      <div key={j} className="p-2">
                        <h4>{sub.subtitle}</h4>
                        <ul className="pt-2">
                          {sub.points.map((sp, k) => <li key={k} className="pb-1">{sp}.</li>)}
                        </ul>
                      </div>
                    ))}
                    {section?.contactDetails && (
                      <div>
                        <div className="text-black"><strong>{section?.contactDetails?.company}</strong></div>
                        <div>{section?.contactDetails?.address}</div>
                        <div><strong>Email:</strong> {section?.contactDetails?.email}</div>
                        <div><strong>Phone:</strong> {section?.contactDetails?.phone}</div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              ))}
            </Col>
          </Row>
        </Container>)
      }
    </div>
  );
};

export default PrivacyPolicy;


// import React from "react";
// import { Card, Container, Row, Col } from "react-bootstrap";

// const policySections = [
//   {
//     title: "Privacy Policy",
//     content:
//       "We are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you use our participant application for accessing courses, training materials, assessments, and related features.",
//   },
//   {
//     title: "Information Collection",
//     content:
//       "We collect information such as your name, email address, course enrollments, attendance records, assignment submissions, exam scores, and messages or queries sent through the platform. Usage data such as login activity and device information may also be collected.",
//   },
//   {
//     title: "How We Use Data",
//     content:
//       "The collected data is used to manage your learning experience, track your progress, deliver course content and lesson plans, respond to queries, and notify you about important updates. We do not sell or share your information with third parties without your explicit consent.",
//   },
//   {
//     title: "Data Security",
//     content:
//       "Your data is stored securely using industry-standard encryption and access controls. Only authorized personnel can access your personal information, and we regularly review our security practices to ensure your data remains protected.",
//   },
//   {
//     title: "Your Rights",
//     content:
//       "You have the right to access, update, or delete your personal information stored on our platform. If you wish to exercise these rights or have concerns about your data, please contact our support team.",
//   },
// ];

// const PrivacyPolicy = () => {
//   return (
//     <div className="content-inner">
//       <Container>
//         <Row>
//           <Col lg="12" className="mb-4">
//             <div className="bg-primary text-white text-center py-4 rounded shadow">
//               <h2 className="mb-0 text-white">Privacy Policy</h2>
//               <p className="mb-0 px-2 mt-2" style={{ lineHeight: "1.4" }}>
//                 Your privacy is important to us — learn how we protect your
//                 data.
//               </p>
//             </div>
//           </Col>
//         </Row>
//         <Row>
//           <Col lg="12">
//             {policySections.map((section, index) => (
//               <Card key={index} className="p-3 p-md-0">
//                 <Card.Header className="d-flex justify-content-between pb-0">
//                   <div className="header-title">
//                     <h4 className="card-title">{section.title}</h4>
//                   </div>
//                 </Card.Header>
//                 <Card.Body className="py-2">
//                   <p>{section.content}</p>
//                 </Card.Body>
//               </Card>
//             ))}
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default PrivacyPolicy;

// // import React from 'react'
// // import { Card, Container, Row, Col } from 'react-bootstrap'

// // const PrivacyPolicy = () => {
// //     return (
// //         <>
// //             <div className='content-inner'>
// //                 <Container fluid className='container'>
// //                     <Row>
// //                         <Col lg="12">
// //                             <Card>
// //                                 <Card.Header className="d-flex justify-content-between pb-0">
// //                                     <div className="header-title">
// //                                         <h4 className="card-title">What is Lorem Ipsum?</h4>
// //                                     </div>
// //                                 </Card.Header>
// //                                 <Card.Body>
// //                                     <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
// //                                 </Card.Body>
// //                             </Card>
// //                             <Card>
// //                                 <Card.Header className="d-flex justify-content-between pb-0">
// //                                     <div className="header-title">
// //                                         <h4 className="card-title">Why do we use it?</h4>
// //                                     </div>
// //                                 </Card.Header>
// //                                 <Card.Body>
// //                                     <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).  </p>
// //                                 </Card.Body>
// //                             </Card>
// //                             <Card>
// //                                 <Card.Header className="d-flex justify-content-between pb-0">
// //                                     <div className="header-title">
// //                                         <h4 className="card-title">Where does it come from?</h4>
// //                                     </div>
// //                                 </Card.Header>
// //                                 <Card.Body>
// //                                     <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
// //                                 </Card.Body>
// //                             </Card>
// //                             <Card>
// //                                 <Card.Header className="d-flex justify-content-between pb-0">
// //                                     <div className="header-title">
// //                                         <h4 className="card-title">Where can I get some?</h4>
// //                                     </div>
// //                                 </Card.Header>
// //                                 <Card.Body>
// //                                     <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
// //                                 </Card.Body>
// //                             </Card>
// //                             <Card>
// //                                 <Card.Header className="d-flex justify-content-between pb-0">
// //                                     <div className="header-title">
// //                                         <h4 className="card-title">Why do we use it?</h4>
// //                                     </div>
// //                                 </Card.Header>
// //                                 <Card.Body>
// //                                     <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
// //                                 </Card.Body>
// //                             </Card>
// //                             <Card>
// //                                 <Card.Header className="d-flex justify-content-between pb-0">
// //                                     <div className="header-title">
// //                                         <h4 className="card-title">Why do we use it?</h4>
// //                                     </div>
// //                                 </Card.Header>
// //                                 <Card.Body>
// //                                     <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
// //                                 </Card.Body>
// //                             </Card>
// //                             <Card>
// //                                 <Card.Header className="d-flex justify-content-between pb-0">
// //                                     <div className="header-title">
// //                                         <h4 className="card-title">Why do we use it?</h4>
// //                                     </div>
// //                                 </Card.Header>
// //                                 <Card.Body>
// //                                     <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
// //                                 </Card.Body>
// //                             </Card>
// //                             <Card>
// //                                 <Card.Header className="d-flex justify-content-between pb-0">
// //                                     <div className="header-title">
// //                                         <h4 className="card-title">Why do we use it?</h4>
// //                                     </div>
// //                                 </Card.Header>
// //                                 <Card.Body>
// //                                     <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
// //                                 </Card.Body>
// //                             </Card>
// //                             <Card>
// //                                 <Card.Header className="d-flex justify-content-between pb-0">
// //                                     <div className="header-title">
// //                                         <h4 className="card-title">Why do we use it?</h4>
// //                                     </div>
// //                                 </Card.Header>
// //                                 <Card.Body>
// //                                     <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).  </p>
// //                                 </Card.Body>
// //                             </Card>
// //                         </Col>
// //                     </Row>
// //                 </Container>
// //             </div>
// //         </>
// //     )
// // }

// // export default PrivacyPolicy
